/**
 * @generated SignedSource<<4d89127fc4bf0c86b102cf3368b87f09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedAuctionPrice_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionPricing_item">;
  readonly " $fragmentType": "SharedAuctionPrice_item";
};
export type SharedAuctionPrice_item$key = {
  readonly " $data"?: SharedAuctionPrice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedAuctionPrice_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedAuctionPrice_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "86a404bd1ba2129c3fd2bf922dd689c9";

export default node;
